module.exports = __webpack_public_path__ + "static/media/26.2dfd4607.png";